import { fromJS, List, Map } from 'immutable';
import {ERROR, START, SUCCESS, COMPLEX} from '../../consts';
import {
  META_LOAD,
  PREMIUM_LOAD,
  DOMAINS_LOAD,
  CIAN_REDIRECT_URL_LOAD,
} from './actionTypes';
import { PREMIUM_LOAD as PREMIUM_LOAD_COMPLEX } from '../Complex/actionTypes';
import { WIDGET_LOAD as ARTICLE_WIDGET_LOAD } from '../Article/actionTypes';

export const DEFAULT_PREMIUM_STATE = new Map({
  loading: false,
  error: null,
  items: new List()
});

export const DEFAULT_STATE = fromJS({
  premium: new Map({
    sale_apartments: DEFAULT_PREMIUM_STATE.slice(),
    sale_commercials: DEFAULT_PREMIUM_STATE.slice(),
    sale_lands: DEFAULT_PREMIUM_STATE.slice(),
    sale_garages: DEFAULT_PREMIUM_STATE.slice(),
    rent_apartments: DEFAULT_PREMIUM_STATE.slice(),
    rentDaily_apartments: DEFAULT_PREMIUM_STATE.slice(),
    rent_commercials: DEFAULT_PREMIUM_STATE.slice(),
  }),
  complex: new Map({
    [COMPLEX.residential]: DEFAULT_PREMIUM_STATE.slice(),
    [COMPLEX.cottage]: DEFAULT_PREMIUM_STATE.slice()
  }),
  articles: DEFAULT_PREMIUM_STATE.slice(),
  meta: new Map({
    loading: false,
    error: null,
    data: new Map()
  }),
  domains: new Map({
    loading: false,
    error: null,
    data: new List()
  }),
  cian_modal_context: new Map()
});

export default function home (state = DEFAULT_STATE, action) {
  switch (action.type) {
    // загрузка объявлений
    case PREMIUM_LOAD + START:
      return state.mergeIn(['premium', action.dealType + '_' + action.realtyType], {
        loading: true,
        error: null
      });
    case PREMIUM_LOAD + SUCCESS:
      return state.mergeIn(['premium', action.dealType + '_' + action.realtyType], {
        loading: false,
        items: action.items
      });
    case PREMIUM_LOAD + ERROR:
      return state.mergeIn(['premium', action.dealType + '_' + action.realtyType], {
        loading: false,
        items: new List(),
        error: action.payload
      });

    // загрузка meta
    case META_LOAD + START:
      return state.mergeIn(['meta'], {
        loading: true,
        error: null
      });
    case META_LOAD + SUCCESS:
      return state.mergeIn(['meta'], {
        loading: false,
        data: action.meta
      });
    case META_LOAD + ERROR:
      return state.mergeIn(['meta'], {
        loading: false,
        data: new Map(),
        error: action.payload
      });

    // загрузка комплексов
    case PREMIUM_LOAD_COMPLEX + START:
      return state.mergeIn(['complex', action.complexType], {
        loading: true,
        error: null
      });
    case PREMIUM_LOAD_COMPLEX + SUCCESS:
      return state.mergeIn(['complex', action.complexType], {
        loading: false,
        items: action.items
      });
    case PREMIUM_LOAD_COMPLEX + ERROR:
      return state.mergeIn(['complex', action.complexType], {
        loading: false,
        items: new List(),
        error: action.payload
      });

    // загрузка комплексов
    case ARTICLE_WIDGET_LOAD + START:
      return state.mergeIn(['articles'], {
        loading: true,
        error: null
      });
    case ARTICLE_WIDGET_LOAD + SUCCESS:
      return state.mergeIn(['articles'], {
        loading: false,
        items: action.items
      });
    case ARTICLE_WIDGET_LOAD + ERROR:
      return state.mergeIn(['articles'], {
        loading: false,
        items: new List(),
        error: action.payload
      });

    case DOMAINS_LOAD + START:
      return state.mergeIn(['domains'], {
        loading: state.get('loading') + 1,
        error: null
      });
    case DOMAINS_LOAD + SUCCESS:
      return state.mergeIn(['domains'], {
        data: action.items,
        loading: state.get('loading') - 1,
      });
    case DOMAINS_LOAD + ERROR:
      return state.mergeIn(['domains'], {
        loading: state.get('loading') - 1,
        data: new List(),
        error: action.payload
      });

    case CIAN_REDIRECT_URL_LOAD + START:
      return state.merge({
        cian_modal_context: new Map()
      });
    case CIAN_REDIRECT_URL_LOAD + SUCCESS:
      return state.merge({
        cian_modal_context: action.payload.getIn(['integration_settings', 'common_popup'])
      });
    case CIAN_REDIRECT_URL_LOAD + ERROR:
      return state.merge({
        cian_modal_context: new Map()
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/Home/reducer.js